import { useCallback, useState } from 'react'

const usePagination = (initialRowsPerPage = 10) => {
	const [totalRows, _setTotalRows] = useState(initialRowsPerPage)
	const [currentPage, setCurrentPage] = useState(0)

	const setTotalRows = useCallback((rows: number) => {
		setCurrentPage(0)
		_setTotalRows(rows)
	}, [])

	return { totalRows, setTotalRows, currentPage, setCurrentPage }
}

export { usePagination }
